import * as Bixby from './../../core';
import { AppState } from './..';
import { VERIFY_COMPANY_INPROGESS, VERIFY_COMPANY_SUCCESS, VERIFY_COMPANY_FAILURE } from './types';
import { ThunkAction } from 'redux-thunk';
import { ClientAdminService } from '$/services/ClientAdminService';

export const verifyCompanyRequestInProgress = () => {
  return {
    type: VERIFY_COMPANY_INPROGESS,
  };
};

export const verifyCompanyRequestSuccess = (companyVerified: boolean) => {
  return {
    type: VERIFY_COMPANY_SUCCESS,
    payload: companyVerified,
  };
};

export const verifyCompanyRequestFailure = (error: Bixby.Models.BixbyError) => {
  return {
    type: VERIFY_COMPANY_FAILURE,
    payload: error,
    error: true,
  };
};

export const verifyCompanyRequest = (
  clientId: string,
  token: string
): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => {
  return async dispatch => {
    dispatch(verifyCompanyRequestInProgress());

    try {
      await ClientAdminService.verifyUserEmailConfirmationToken(clientId, token);
      dispatch(verifyCompanyRequestSuccess(true));
    } catch (error: any) {
      dispatch(verifyCompanyRequestFailure(error));
    }
  };
};
